import { configureStore } from '@reduxjs/toolkit';
import { timumApiSlice } from '@timum/timum_pdk';
import appStateReducer from '../slices/appState';

export function createStore(instanceId) {
  return configureStore({
    reducer: {
      [timumApiSlice.reducerPath]: timumApiSlice.reducer,
      appState: appStateReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // The MUI theme is intentionally kept in Redux so postMessage-driven
          // theme changes re-render subscribers. It legitimately carries callback
          // styleOverrides (e.g. MuiListItem/MuiListItemButton read
          // theme.shape.borderRadius dynamically — see src/defaults.jsx), which
          // are not serializable. Exclude the theme subtree and its setter from
          // the dev-only serializability check.
          ignoredActions: ['appState/setMuiTheme'],
          ignoredPaths: ['appState.muiTheme'],
        },
      }).concat(timumApiSlice.middleware),
    preloadedState: {
      appState: { isWaitingForConf: true, instanceId },
    },
    devTools: { trace: true },
  });
}

// Default singleton for backward compatibility (iframe paths, single-instance usage)
export default createStore('default');
